import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  message,
  Select,
  Card,
  Space,
  Upload,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { useLocation, useNavigate } from "react-router-dom";
import { UploadOutlined } from "@ant-design/icons";

function AddProduct() {
  const location = useLocation();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [response, request] = useApi(
    "/config/product",
    null,
    API_METHODS.POST,
    true
  );

  const [categoryResponse, categoryRequest] = useApi(
    "/config/category/dropdown",
    null,
    API_METHODS.GET
  );

  const [subcategoryResponse, subcategoryRequest] = useApi(
    "/config/subcategory/category/",
    null,
    API_METHODS.GET
  );

  const [categories, setcategories] = useState([]);

  const [subcategories, setsubcategories] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    categoryRequest();
  }, []);

  useEffect(() => {
    const data =
      categoryResponse.data !== BLANK_VALUE ? categoryResponse.data : [];
    setcategories(data);
  }, [categoryResponse]);

  useEffect(() => {
    if (response.error) {
      messageApi.open({
        type: "error",
        content: response.error,
      });
    } else if (response.data) {
      messageApi.open({
        type: "success",
        content: "Product added successfully.",
      });
      navigate("/portal/setting/products");
    }
  }, [response]);

  useEffect(() => {
    const data =
      subcategoryResponse.data !== BLANK_VALUE ? subcategoryResponse.data : [];
    setsubcategories(data);
  }, [subcategoryResponse]);

  const categoryChanged = (category_id) => {
    form.setFieldValue("subcategory_id", null);
    subcategoryRequest(
      null,
      API_METHODS.GET,
      `/config/subcategory/category/${category_id}`
    );
  };

  const uploadProps = {
    // beforeUpload: (file) => {
    //   const isExcel = isExcelFile(file);
    //   if (!isExcel) {
    //     messageApi.open({
    //       type: "error",
    //       content: "Excel Files are supported.",
    //     });
    //   }
    //   return isExcel || Upload.LIST_IGNORE;
    // },
    multiple: true,
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const Finish = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        formData.append("price", values.price);
        formData.append("category_id", values.category_id);
        formData.append("subcategory_id", values.subcategory_id);
        formData.append(
          "file",
          values["file"].file.originFileObj,
          values["file"].file.name
        );
        if (values["video"]) {
          formData.append(
            "video",
            values["video"].file.originFileObj,
            values["video"].file.name
          );
        }
        for (const photo of values.photos.fileList) {
          formData.append("photos", photo.originFileObj, photo.name);
        }

        request(formData);
      })
      .catch((e) => {});
  };

  return (
    <Card title="Upload Product">
      {contextHolder}
      <Form layout="vertical" form={form} onFinish={Finish}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="file"
              label="Product File"
              rules={[{ required: true, message: "Product File is required." }]}
            >
              <Upload
                customRequest={dummyRequest}
                // {...uploadProps}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload Product</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="price"
              label="Price"
              rules={[{ required: true, message: "Price is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="category_id"
              label="Category"
              rules={[{ required: true, message: "Category is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onChange={categoryChanged}
              >
                {categories?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {subcategories?.length > 0 && (
            <Col span={8}>
              <Form.Item
                name="subcategory_id"
                label="Subcategory"
                rules={[
                  { required: true, message: "Subcategory is required." },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {subcategories.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.subcategory}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item
              name="photos"
              label="Product Photos"
              rules={[
                { required: true, message: "Product Photos is required." },
              ]}
            >
              <Upload
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={6}
              >
                <Button icon={<UploadOutlined />}>
                  Click to Upload Photos
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="video" label="Product Video">
              <Upload
                customRequest={dummyRequest}
                // {...uploadProps}
                maxCount={6}
              >
                <Button icon={<UploadOutlined />}>Click to Upload Video</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Space style={{ float: "right" }}>
              <Form.Item label={null}>
                <Button type="default" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item label={null}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={response.isLoading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default AddProduct;
